import i18n from 'i18next';
import { MAXALLOWEDFILES } from './const';

export const getValidationMessage = (numberOfFiles = MAXALLOWEDFILES) => ({
    mandatoryError: i18n.t('validation.mandatoryField'),
    format: i18n.t('validation.wrongFormat'),
    size: i18n.t('validation.wrongSize'),
    maxUploadCount: i18n.t('validation.maxUploadCount').replace('{maxUploadCount}', String(numberOfFiles)),
});
